<template>
    <div>
        <section class="accordions">
            <article class="accordion" :class="{'is-active': newPinVisible}">
                <div
                    class="accordion-header toggle is-size-5"
                    @click="newPinVisible = !newPinVisible"
                >
                    <a>Create pin ⯆</a>
                </div>
                <div class="accordion-body">
                    <div class="accordion-content has-background-dark has-text-white">
                        <div class="field">
                            <label class="label">Currency</label>
                            <div class="control">
                                <div class="select">
                                    <select v-model="newPin.currency">
                                        <option
                                            v-for="currency in currencies"
                                            :key="currency.id"
                                        >{{currency.id}}</option>
                                    </select>
                                </div>
                            </div>
                            <p
                                class="help is-danger"
                                v-if="!$v.newPin.currency.required"
                            >Currency is required</p>
                        </div>
                        <div class="field">
                            <label class="label">Pin value</label>
                            <div class="control">
                                <currency-input
                                    v-if="newPin.currency"
                                    :value="newPin.value"
                                    :currency="newPin.currency"
                                    :set="(val) => newPin.value = val"
                                    class="input oc-input"
                                />
                            </div>
                            <p
                                class="help is-danger"
                                v-if="!$v.newPin.value.required"
                            >Enter pin value</p>
                            <p
                                class="help is-danger"
                                v-if="!$v.newPin.value.minValue"
                            >Min pin value is 0.01</p>
                        </div>
                        <div class="field">
                            <label class="label"></label>
                            <div class="control">
                                <label class="checkbox">
                                    <input type="checkbox" v-model="newPin.isDemo" />
                                    Demo pin
                                </label>
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Branch</label>
                            <div class="control">
                                <input class="input oc-input" type="text" v-model="newPin.branch" />
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Description</label>
                            <div class="control">
                                <input
                                    class="input oc-input"
                                    type="text"
                                    v-model="newPin.description"
                                />
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Count</label>
                            <div class="control">
                                <input class="input oc-input" type="number" v-model="newPinsCount" />
                            </div>
                        </div>
                        <div class="field">
                            <label class="label"></label>
                            <div class="control">
                                <label class="checkbox">
                                    <input type="checkbox" v-model="downloadPins" />
                                    Download pins
                                </label>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <button
                                    class="button is-success"
                                    @click="create()"
                                    :disabled="$v.$invalid"
                                >Create pin</button>
                                <button
                                    class="button is-success"
                                    @click="createBonus()"
                                    :disabled="$v.$invalid"
                                >Create bonus pin</button>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </section>

        <pin-list ref="pinList" :data-func="loadPins" />
    </div>
</template>

<script>
import state from '../../../state';
import pinService from '../../../services/pin.service';
import currencyService from '../../../services/currency.service';
import utils from '../../../utils';

import PinList from '../../common/pin-list.vue';
import CurrencyInput from '../../common/currency-input.vue';

import { required, minValue } from 'vuelidate/lib/validators';

export default {
    name: 'client-pins',
    components: { PinList, CurrencyInput },
    data() {
        return {
            newPinVisible: false,
            newPin: {
                value: 0,
                currency: null,
                branch: null,
                description: null
            },
            newPinsCount: 1,
            downloadPins: true
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        client() {
            return state.clients.getClient(this.clientId);
        },
        currencies() {
            return state.currencies.get();
        }
    },
    validations: {
        newPin: {
            value: {
                required,
                minValue: minValue(0.01)
            },
            currency: {
                required
            }
        }
    },
    watch: {
        async client() {
            await this.$refs.pinList.load();
        }
    },
    async mounted() {
        await currencyService.ensure();
        await this.$refs.pinList.load();
    },
    methods: {
        async loadPins(filter) {
            return await pinService.getByClient(this.clientId, filter);
        },
        async create() {
            this.createPins(async () => {
                return await pinService.createFreePin(
                    this.clientId,
                    this.newPin.value,
                    this.newPin.currency,
                    this.newPin.branch,
                    this.newPin.description,
                    this.newPin.isDemo
                );
            }, 'real');
        },
        async createBonus() {
            this.createPins(async () => {
                return await pinService.createBonusPin(
                    this.clientId,
                    this.newPin.value,
                    this.newPin.currency,
                    this.newPin.branch,
                    this.newPin.description,
                    this.newPin.isDemo
                );
            }, 'bonus');
        },
        async createPins(createPinFunc, pinType) {
            if (!this.newPinsCount) return;
            let newPins = [];
            for (var i = 0; i < this.newPinsCount; i++) {
                let p = await createPinFunc();
                newPins.push(p);
            }

            if (this.downloadPins) {
                let txt = newPins.map(p => p.pin).join('\r\n');
                let fileName = `${newPins.length} ${pinType} pins ${this.newPin.value} ${this.newPin.currency} each.txt`;
                utils.saveText(txt, fileName);
            }

            await this.$refs.pinList.load();
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/pins.vue